
import React, { useState } from 'react';

import { connect } from 'react-redux';
import { Action } from 'redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { ThunkDispatch } from 'redux-thunk';

import { RootState } from '@share/utils';
import { ICompanyProfileState, deleteCompanyCard } from '@share/store/slices';
import { ModalConfirmation } from '@components';
import { ICompanyCard } from '@share/common-types';
import { GetCreditCardImage } from '@utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

import './style.scss';

interface IMapStateToProps {
  companyProfileStore: ICompanyProfileState;
}

interface IMapDispatchToProps {
  deleteCompanyCard: (companyCard: ICompanyCard, sucessCallBack: () => void) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, RouteComponentProps, WrappedComponentProps {
  card: ICompanyCard;
  hideDelete?: boolean;
}

function CompanyCreditCardItemComponent(props: IProps) {

  const { card, companyProfileStore, hideDelete, deleteCompanyCard } = props;
  const { loadingCards } = companyProfileStore;

  const [ showConfirmation, setShowConfirmation ] = useState(false);
  const [ selectedCard, setSelectedCard ] = useState(null);

  const handleConfirmDelete = () => {
    deleteCompanyCard(selectedCard as unknown as ICompanyCard, () => {
      setSelectedCard(null);
    });
    setShowConfirmation(false);
  }

  const year = card.expireDate?.substring(card.expireDate.length - 2);
  const month = card.expireDate?.substring(0, 2);

  return (
    <>
        <div className="credit-cards-list__credit-card-item">
          <div className="input-card" style={{ marginRight: '20px', width: '41px', height: '24px' }}>
            {GetCreditCardImage(card.cardType || '', true)}
          </div>

          <label>**** **** **** {card.cardNumber?.substring(card.cardNumber.length - 4)}</label>
          <label style={{ marginLeft: '20px' }}>(EXP: {month}/{year})</label>

          {!hideDelete ? (
            <div className="credit-cards-list__credit-card-delete" onClick={() => {
              setShowConfirmation(true);
              setSelectedCard(card as ICompanyCard);
            }}>
              <FontAwesomeIcon icon={faTimesCircle} />
            </div>) : null}
        </div>

        <ModalConfirmation
          message="confirm.delete.credit.card"
          title="delete.credit.card"
          yesMessage="confirm.button"
          noMessage="cancel.button"
          visible={showConfirmation}
          disabled={loadingCards}
          onCancel={() => {
            if (!loadingCards) {
              setShowConfirmation(false);
              setSelectedCard(null);
            }
          }}
          onConfirm={handleConfirmDelete}
        />
    </>
  );
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    companyProfileStore: state.companyProfileStore,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, undefined, Action>): IMapDispatchToProps => ({
  deleteCompanyCard: (companyCard: ICompanyCard, sucessCallBack: () => void) => {
    dispatch(deleteCompanyCard(companyCard, sucessCallBack));
  }
});

const ComponentIntl = injectIntl(CompanyCreditCardItemComponent);

export const CompanyCreditCardItem = connect(mapStateToProps, mapDispatchToProps)(withRouter(ComponentIntl));
